import imageUrlBuilder from '@sanity/image-url'

export default ({ env }, inject) => {
  const builder = imageUrlBuilder({
    projectId: env.sanityProjectId,
    dataset: env.sanityDataset
  })
  inject('sanityImage', source => builder.image(source))
}
